import React from 'react';
import { injectIntl, useIntl } from 'react-intl';
import {
    useHandleToggleFavorite,
    useIsFavorite,
} from '../../../hooks/use-is-favorite';
interface Props {
    accesoryName: string;
    productNumber: string;
    imageUrl?: string;
    quantity: number;
    onQuantityChanged: (partNumber: string, quantity: number) => void;
    itemGuid: string;
    patientOrder: boolean;
}

const AccessoryElement: React.FC<Props> = ({
    accesoryName,
    productNumber,
    imageUrl,
    quantity,
    onQuantityChanged,
    itemGuid,
    patientOrder,
}) => {
    const intl = useIntl();
    const addDelete = (add: boolean) => {
        add
            ? onQuantityChanged(productNumber, quantity + 1)
            : onQuantityChanged(productNumber, quantity - 1);
    };

    const isFavorite = useIsFavorite();
    const handleToggleFavorite = useHandleToggleFavorite();

    return (
        <div style={{ marginRight: '20px', maxWidth: '300px' }}>
            <img className="col-sm-12" alt={accesoryName} src={imageUrl} />
            <div />
            <div className="col-sm-12" style={{ height: '75px' }}>
                <h3
                    id="accessory-name"
                    className="col-sm-10 container"
                    style={{
                        fontSize: 'small',
                        paddingLeft: '0px',
                        height: '100%',
                        overflow: 'hidden',
                    }}
                >
                    {accesoryName}
                </h3>
                <h3 className="col-sm-2">
                    <button
                        id="accessory-favorite-btn"
                        type="button"
                        className="btn-link"
                        onClick={() => handleToggleFavorite(itemGuid)}
                    >
                        <i
                            className={`fa${
                                isFavorite(itemGuid) ? 's' : 'r'
                            } fa-star pull-right`}
                        />
                    </button>
                </h3>
            </div>
            <h4 className="col-sm-12" id="accessory-part-number">
                {productNumber}
            </h4>
            {quantity >= 1 && (
                <>
                    <div className="col-sm-5">
                        <div
                            className="btn-group container"
                            role="group"
                            style={{ marginLeft: '-20px' }}
                        >
                            {patientOrder ? (
                                <div
                                    style={{
                                        display: 'flex',
                                    }}
                                >
                                    <div
                                        style={{
                                            alignItems: 'center',
                                            padding: '1%',
                                        }}
                                    >
                                        <span
                                            id="accessory-selected"
                                            style={{
                                                fontSize: 'large',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {intl.formatMessage({
                                                id: 'Selected',
                                                defaultMessage: 'Selected',
                                            })}
                                        </span>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <button
                                        id="accessory-minus"
                                        type="button"
                                        className="btn btn-group-sm btn-default"
                                        onClick={() => addDelete(false)}
                                    >
                                        -
                                    </button>
                                    <input
                                        id="accessory-quantity"
                                        type="text"
                                        className="btn btn-group-sm btn-default"
                                        style={{ width: '55px' }}
                                        value={intl.formatNumber(quantity)}
                                        readOnly={true}
                                    />
                                    <button
                                        id="accessory-add"
                                        type="button"
                                        className="btn btn-group-sm btn-default"
                                        onClick={() => addDelete(true)}
                                    >
                                        +
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="col-sm-2" />
                </>
            )}
            <div className="col-sm-5">
                {quantity <= 0 ? (
                    <button
                        id="accessory-select"
                        type="button"
                        onClick={() => addDelete(true)}
                        className="btn btn-primary btn-sm"
                    >
                        {intl.formatMessage({
                            id: 'Select',
                            defaultMessage: 'Select',
                        })}
                    </button>
                ) : (
                    <button
                        id="accessory-cancel"
                        type="button"
                        onClick={() => onQuantityChanged(productNumber, 0)}
                        className="btn btn-danger btn-sm"
                    >
                        {intl.formatMessage({
                            id: 'Cancel',
                            defaultMessage: 'Cancel',
                        })}
                    </button>
                )}
            </div>
        </div>
    );
};

export default AccessoryElement;
